module.exports = __webpack_public_path__ + "img/ekomi_bewertung_70px.d20cd30f.png";